import _implicitStylesheets from "./loginMotivation.css";
import _implicitScopedStylesheets from "./loginMotivation.scoped.css?scoped=true";
import _wdsButton from "wds/button";
import _adsIcon from "ads/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="character-container${0}"${2}><img class="character${0}" src="/images/home/appy-astronaut.png" alt="astronaut"${2}></div>`;
const $fragment2 = parseFragment`<div class="text${0}" type-style="body-3"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "banner-container": true
  },
  attrs: {
    "grid": "",
    "size": "12:12",
    "flow": "unset",
    "axis": "vertical",
    "align-items": "center"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "inner-container": true
  },
  attrs: {
    "grid": "",
    "bump": "right",
    "axis": "vertical"
  },
  key: 3
};
const stc2 = {
  classMap: {
    "button-group": true
  },
  attrs: {
    "grid": "",
    "flow": "unset"
  },
  key: 6
};
const stc3 = {
  "signup": true,
  "banner-button": true
};
const stc4 = {
  "login": true,
  "banner-button": true
};
const stc5 = {
  classMap: {
    "control": true
  },
  key: 9
};
const stc6 = {
  "close": true
};
const stc7 = {
  "href": "javascript:void(0)"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {st: api_static_fragment, d: api_dynamic_text, sp: api_static_part, b: api_bind, c: api_custom_element, h: api_element} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [$cmp.shouldShowMotivation ? api_element("div", stc0, [api_static_fragment($fragment1, 2), api_element("div", stc1, [api_static_fragment($fragment2, 5, [api_static_part(1, null, api_dynamic_text($cmp.i18n.loginMotivationBanner.bannerText))]), api_element("div", stc2, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc3,
    props: {
      "name": "toastSignup",
      "label": $cmp.i18n.header.signup,
      "size": "small"
    },
    key: 7,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.signup))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc4,
    props: {
      "name": "toastLogin",
      "label": $cmp.i18n.header.login,
      "variant": "secondary",
      "size": "small"
    },
    key: 8,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.login))
    }
  })])]), api_element("div", stc5, [api_element("a", {
    classMap: stc6,
    attrs: stc7,
    key: 10,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.close))
    }
  }, [api_custom_element("ads-icon", _adsIcon, {
    props: {
      "symbol": "close",
      "spriteSheet": "symbols",
      "size": "small",
      "fill": $cmp.iconBrand
    },
    key: 11
  })])])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5au2g6f2jlo";
tmpl.legacyStylesheetToken = "undefined-_loginMotivation";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
